import { Divider, Flex, Text } from "@mantine/core";
import { IconCheck, IconNorthStar } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

const Stat = ({ value, label }) => (
    <div>
        <Text fz={14} fw={600}>{value}</Text>
        <Text fz={12}  color="rgb(80, 80, 80)">{label}</Text>
    </div>
);

export const AIDetectionFeature = ({ ultimate = false }) => {
    const { t } = useTranslation(["common"]);
    const mode = ultimate ? "ultimate" : "standard";

    return (
        <>
            <Flex align={"center"} gap={"0.25rem"}>
                {ultimate ?
                    <IconNorthStar size={16} stroke={2} style={{ flexShrink: 0, color: "var(--yellow)" }} />
                    :
                    <IconCheck size={16} style={{ flexShrink: 0 }} />
                }
                <p style={{fontSize: "15px", fontWeight: 400}}>{t(`upgrade.ai-detection.${mode}`)}</p>
            </Flex>
            <Flex gap={"1.5rem"} ml={"1.25rem"} mt={"0"}>
                <Stat value={t(`upgrade.ai-detection.${mode}-efficiency`)} label={t("upgrade.ai-detection.efficiency")} />
                <Stat value={t(`upgrade.ai-detection.${mode}-false-positives`)} label={t("upgrade.ai-detection.false-positives")} />
            </Flex>
            <Divider my={"0.5rem"} />
        </>
    );
};
